import { Component } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import ForecastSelector from "components/forecast-selector"
import { Button } from "@mui/material"
import "./style.scss"

const EMPTY_STATE = {
  menuParent: null,
}

class General extends Component {
  constructor(...args) {
    super(...args)
    this.state = EMPTY_STATE
  }

  static propTypes = {
    resetSettings: PropTypes.func.isRequired,
    setSetting: PropTypes.func.isRequired,
    applySettings: PropTypes.func.isRequired,
    computedSettings: PropTypes.object.isRequired,
    openDialog: PropTypes.func.isRequired,
    settings: PropTypes.object.isRequired,
    applySettingsButtonEnabled: PropTypes.bool.isRequired,
    forecasts: PropTypes.array,
    selectedForecast: PropTypes.object,
    reversedActions: PropTypes.bool,
    isOpPro: PropTypes.bool,
  }

  onApply = () => {
    const { applySettings, computedSettings } = this.props
    applySettings(computedSettings)
  }

  onResetSettings = () => {
    this.props.openDialog({
      title: "Reset",
      contentText: "This will reset all general, forecast, constraints, factor and security targets options.",
      buttons: [{
        text: "Confirm",
        type: "primary",
        action: this.props.resetSettings,
      }],
    })
  }

  setForecast = selected => {
    const { setSetting } = this.props
    setSetting("forecast", selected)
    this.setState(EMPTY_STATE)
  }

  setHorizon = horizon => {
    const { setSetting } = this.props
    setSetting("horizon", horizon)
  }

  render() {
    const { settings, applySettingsButtonEnabled, forecasts, selectedForecast, reversedActions, isOpPro } = this.props

    return <div className="general-panel">
      <ForecastSelector
        forecasts={forecasts}
        selectedForecast={selectedForecast}
        setForecast={this.setForecast}
        setHorizon={this.setHorizon}
        horizon={settings.horizon.value}
        isOpPro={isOpPro}
      />
      <div className={classNames("buttons-bar", { reversed: reversedActions })}>
        <Button variant="contained" color="primary" onClick={this.onApply} disabled={!applySettingsButtonEnabled}>Apply</Button>
        <Button variant="outlined" className="reset-button" onClick={this.onResetSettings}>Reset optimizer options</Button>
      </div>
    </div>
  }
}

export default General
